<template>
    <div v-if="annotation.guaranteesDetailed && annotation.guaranteesDetailed.length > 0">
        <typo :class="cspClasses" name="ci-body">
            <table>
                <tbody>
                    <tr>
                        <th>Garantie</th>
                        <th>Détails</th>
                    </tr>
                    <tr
                        v-for="guaranteeDetail in annotation.guaranteesDetailed"
                        :key="guaranteeDetail._uid"
                    >
                        <td>{{ getOptionLabel(guaranteeDetail.guarantee) }}</td>
                        <td v-html="guaranteeDetail.detail" />
                    </tr>
                </tbody>
            </table>
        </typo>
    </div>
</template>

<script>
import Vue from "vue";
import { get, upperFirst } from "lodash";

export default Vue.extend({
    props: ["annotation", "annotationOptions"],
    computed: {
        cspClasses() {
            return this.annotation.cspCodes
                .map(code => `csp-${code}`)
                .join(" ")
                .toLowerCase();
        },
    },
    methods: {
        getOptionLabel(code) {
            return upperFirst(get(this.annotationOptions, `${code}.label`, "").toLowerCase());
        },
    },
});
</script>

<style lang="sass" scoped>
table
    width: 100%
    margin: 16px 0 16px 0
    border-collapse: collapse
    border-radius: 5px
    display: table
    th
        background: $color-yellow
        color: $color-secondary
        padding: 5px 10px
        border: 1px solid transparentize($color-secondary, 0.4)
        &:first-child
            width: 200px

    td
        border: 1px solid transparentize($color-secondary, 0.4)
        padding: 5px
</style>
